import styled from '@emotion/styled';

export const LoadingContainer = styled.div`
	background-color: hwb(0deg 0% 100% / 5%);
	position: fixed;
	display: flex;
	flex-direction: row;
	align-items: center;
	text-align: -webkit-center;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: var(--z-index-10);
`;

export const LottieContainer = styled.div`
	margin: auto;
`;
